<template>
    <div class="customer__finance">
        <div class="md-layout">
            <div class="md-layout-item md-size-33 pr">
                <z-select v-model="filter.type">
                    <option value="" selected>Тип (все)</option>
                    <option value="1">Приход</option>
                    <option value="2">Расход</option>
                </z-select>
            </div>
            <div class="md-layout-item md-size-33 pr">
                <z-select v-model="filter.operation_type">
                    <option value="" selected>Тип операции (все)</option>
                    <option value="1">Поручение</option>
                    <option value="2">Заявка</option>
                </z-select>
            </div>

            <div class="md-layout-item md-size-33">
                <z-select v-model="filter.company_id">
                    <option value="" selected>Получатель (все)</option>
                    <option
                        v-for="c in Object.values(companies)"
                        v-bind:value="c.id" v-bind:key="`customer__finance-company-${c.id}`"
                    >{{ c.name }}</option>
                </z-select>
            </div>

            <div class="md-layout-item md-size-50 pr">
                <z-date v-model="filter.date_from" no-margin reset v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата от"></z-date>
            </div>
            <div class="md-layout-item md-size-50">
                <z-date v-model="filter.date_to" no-margin reset v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата до"></z-date>
            </div>
        </div>
        <sort-table
            v-bind:columns="tableColumns" v-model="operationsFiltered" table-id="customer-operations" noFooter link linkTarget="_blank"
            v-bind:noBreackColumns="['datetime', 'sum', 'balance_coming', 'balance_consumption', 'balance_sum_before', 'balance_sum_after']"
            @refresh="refreshOperations" :refreshOnCreate="false" defaultSort="datetime" defaultOrder="asc"
        >
            <template slot="company_id" slot-scope="scope">{{ scope.item.company ? scope.item.company.name : '' }}</template>
            <template slot="payment_method_id" slot-scope="scope">{{ scope.item.payment_method ? scope.item.payment_method.name : '' }}</template>
            <template slot="datetime" slot-scope="scope">
                <div v-if="scope.item && scope.item.date">
                    <div>{{ moment(scope.item.date).format("DD.MM.YY") }}</div>
                    <div>{{ moment(scope.item.date).format("HH:mm:ss") }}</div>
                </div>
            </template>
            <template slot="operation_type" slot-scope="scope">
                <span v-if="parseInt(scope.item.operation_type) === 1" class="customer__finance-table-value-item finance">Поручение</span>
                <span v-if="parseInt(scope.item.operation_type) === 2" class="customer__finance-table-value-item deal">Заявка</span>
                <span v-if="parseInt(scope.item.operation_type) === 3" class="customer__finance-table-value-item balance">Сальдо</span>
            </template>

            <template slot="number" slot-scope="scope">
                <div>
                    <div>{{ scope.item.number  ? scope.item.number  : '--' }}</div>
                    <div>{{ scope.item.ones_id ? scope.item.ones_id : '--' }}</div>
                </div>
            </template>

            <template slot="sum" slot-scope="scope">{{ priceFormat(scope.item.sum) }}</template>
            <template slot="balance_coming" slot-scope="scope">
                <span v-if="parseInt(scope.item.type) === 1" class="customer__finance-table-value-item plus">{{ priceFormat(scope.item.sum) }}</span>
                <span v-else>{{ priceFormat(0) }}</span>
            </template>
            <template slot="balance_consumption" slot-scope="scope">
                <span v-if="parseInt(scope.item.type) === 2" class="customer__finance-table-value-item minus">{{ priceFormat(scope.item.sum) }}</span>
                <span v-else>{{ priceFormat(0) }}</span>
            </template>

            <template slot="balance_sum_before" slot-scope="scope">
                <div v-if="filter.company_id" v-bind:class="{
                    'customer__finance-table-value-item minus': scope.item.company_balance_before && parseFloat(scope.item.company_balance_before.sum) < 0,
                    'customer__finance-table-value-item plus':  scope.item.company_balance_before && parseFloat(scope.item.company_balance_before.sum) > 0,
                }">{{ scope.item.company_balance_before ? priceFormat(scope.item.company_balance_before.sum) : 0 }}</div>

                <div v-else v-bind:class="{
                    'customer__finance-table-value-item minus': scope.item.balance_before && parseFloat(scope.item.balance_before.sum) < 0,
                    'customer__finance-table-value-item plus':  scope.item.balance_before && parseFloat(scope.item.balance_before.sum) > 0,
                }">{{ scope.item.balance_before ? priceFormat(scope.item.balance_before.sum) : 0 }}</div>
            </template>

            <template slot="balance_sum_after" slot-scope="scope">
                <div v-if="filter.company_id" v-bind:class="{
                    'customer__finance-table-value-item minus': scope.item.company_balance_after && parseFloat(scope.item.company_balance_after.sum) < 0,
                    'customer__finance-table-value-item plus':  scope.item.company_balance_after && parseFloat(scope.item.company_balance_after.sum) > 0,
                }">{{ scope.item.company_balance_after ? priceFormat(scope.item.company_balance_after.sum) : 0 }}</div>

                <div v-else v-bind:class="{
                    'customer__finance-table-value-item minus': scope.item.balance_after && parseFloat(scope.item.balance_after.sum) < 0,
                    'customer__finance-table-value-item plus':  scope.item.balance_after && parseFloat(scope.item.balance_after.sum) > 0,
                }">{{ scope.item.balance_after ? priceFormat(scope.item.balance_after.sum) : 0 }}</div>
            </template>
        </sort-table>

        <div class="customer__finance__footer">
            <table class="entity-card-footer">
                <tr>
                    <td
                        v-for="(field, i) in tableColumns"
                        v-bind:key="`customer__finance__footer-field-${field.field}-${i}`"
                        :class="{'customer__finance__footer-item': true, [`footer-item__${field.field}`]: true}"
                        :style="`width: ${field.width}`"
                    >
                        <div v-if="field.field == 'payment_method_id'">Сальдо</div>
                        <div v-else-if="field.field == 'balance_coming'">
                            <span v-if="parseInt(totalSum.type) === 1" class="customer__finance-table-value-item plus">{{ priceFormat(totalSum.sum) }}</span>
                            <span v-else>{{ priceFormat(0) }}</span>
                        </div>
                        <div v-else-if="field.field == 'balance_consumption'">
                            <span v-if="parseInt(totalSum.type) === 2" class="customer__finance-table-value-item minus">{{ priceFormat(totalSum.sum) }}</span>
                            <span v-else>{{ priceFormat(0) }}</span>
                        </div>
                        <div
                            v-else-if="field.field == 'balance_sum_before'"
                            v-bind:class="{
                                'customer__finance-table-value-item minus': totalSum.balance_before && parseFloat(totalSum.balance_before.sum) < 0,
                                'customer__finance-table-value-item plus':  totalSum.balance_before && parseFloat(totalSum.balance_before.sum) > 0,
                            }"
                        >{{ totalSum.balance_before ? priceFormat(totalSum.balance_before.sum) : 0 }}</div>
                        <div
                            v-else-if="field.field == 'balance_sum_after'"
                            v-bind:class="{
                                'customer__finance-table-value-item minus': totalSum.balance_after && parseFloat(totalSum.balance_after.sum) < 0,
                                'customer__finance-table-value-item plus':  totalSum.balance_after && parseFloat(totalSum.balance_after.sum) > 0,
                            }"
                        >{{ totalSum.balance_after ? priceFormat(totalSum.balance_after.sum) : 0 }}</div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import ZDate       from '@/components/ZDate';
    import ZInput      from '@/components/ZInput';
    import ZSelect     from '@/components/ZSelect';
    import ZButton     from '@/components/ZButton.vue';
    import SortTable   from "@/components/SortTable";
    import ToggleCard  from '@/components/ToggleCard';
    import priceFormat from "@/mixins/priceFormat";
    export default {
        components: { ZDate, ZInput, ToggleCard, ZSelect, ZButton, SortTable },
        props: {
            customerId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                priceFormat: priceFormat,
                dbOperations: {},
                operations: [],
                filter: {
                    type: null,
                    operation_type: null,
                    company_id: null,
                    date_from: null,
                    date_to: null,
                },
                orderBy: 'date',
                orderType: 'asc',
                tableColumns: [
                    { label: 'Тип',        field: 'operation_type',      sortable: true,  width: '80px'  },
                    { label: 'Дата',       field: 'datetime',            sortable: true,  width: '70px'  },
                    { label: '№ CRM/1С',   field: 'number',              sortable: false, width: '130px' },
                    { label: 'Получатель', field: 'company_id',          sortable: true,  width: '200px' },
                    { label: 'Оплата',     field: 'payment_method_id',   sortable: true,  width: '100px' },
                    { label: 'Сальдо нач', field: 'balance_sum_before',  sortable: false, width: '150px' },
                    { label: 'Приход',     field: 'balance_coming',      sortable: false, width: '100px' },
                    { label: 'Расход',     field: 'balance_consumption', sortable: false, width: '100px' },
                    { label: 'Сальдо кон', field: 'balance_sum_after',   sortable: false, width: '150px' },
                ],
                total: {},
                totalDefault: {
                    id: 0,
                    datetime: 0,
                    date:     '',
                    ones_id:  '',
                    number:   '',
                    sum:       0,
                    type:      3,
                    company_id:  0,
                    customer_id: 0,
                    payment_method_id: 0,
                    payment_method:  { name: 'Сальдо' },
                    operation_type:  3,
                    balance_before: {
                        coming: 0,
                        consumption: 0,
                        sum: 0,
                    },
                    balance_after: {
                        coming: 0,
                        consumption: 0,
                        sum: 0,
                        result: false,
                    },
                }
            }
        },
        created() {
            this.total = Object.assign({}, this.totalDefault);
            this.getFinance()
            this.getCompanies()
        },
        watch: {
            '$props.customerId' () {
                this.total = Object.assign({}, this.totalDefault);
                this.getFinance()
            }
        },
        computed: {
            /**
             * Список компаний
             * @returns Array
             */            
            companies() {
                const companies = this.$store.state.companies.companies || []
                const result = {}
                companies.forEach(c => {
                    if (!result[parseInt(c.id)]) result[parseInt(c.id)] = c
                });
                return result
            },
            operationsFiltered() {
                return this.operations.filter(i => {
                    if (this.filter.type && parseInt(this.filter.type) !== parseInt(i.type)) return false;
                    if (this.filter.operation_type && parseInt(this.filter.operation_type) !== parseInt(i.operation_type)) return false;
                    if (this.filter.date_from  && (new Date(this.filter.date_from).valueOf() / 1000) > i.datetime) return false;
                    if (this.filter.date_to    && (new Date(this.filter.date_to).valueOf() / 1000) < i.datetime) return false;
                    if (this.filter.company_id && parseInt(this.filter.company_id) !== parseInt(i.company_id)) return false;
                    return true;
                }).map(i => {
                    i.company = null;
                    if (i.company_id && this.companies && this.companies[i.company_id])
                        i.company = this.companies[i.company_id]

                    if (parseInt(i.operation_type) === 1) // Поручение
                        i.routerLink = { name: 'Operation', params: { operation_id: i.id }, query: {
                            page: 1, perpage: 50, orderBy: 'payment_number', orderType: 'desc',
                        } };
                    else if (parseInt(i.operation_type) === 2) // Заявка
                        i.routerLink = { name: 'DealNew', params: { id: i.id } };

                    return i
                });
            },
            totalSum() {
                if (!this.filter.company_id) return this.total;
                else {
                    if (this.dbOperations.total_company && this.dbOperations.total_company[this.filter.company_id])
                        return this.dbOperations.total_company[this.filter.company_id];
                    else return this.totalDefault;
                }
            }
        },
        methods: {
            /**
             * Получение финансовых операций 
             */
            getFinance() {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch('customers/getCustomerFinance', this.$props.customerId)
                    .then(r => {
                        this.dbOperations = Object.assign({}, r);
                        this.operations   = Object.values(r.items);
                        this.total = Object.assign({}, r.total);
                        this.refreshOperations(0, 0, 'datetime', 'asc')
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            refreshOperations(page, count, orderBy, orderType) {
                this.operations.sort((a, b) => {
                    if (orderType == 'asc') return a[orderBy] - b[orderBy]
                    else return b[orderBy] - a[orderBy]
                })
            },
            /**
             * Получает список компаний - исполнителей из API
             * @returns Promise
             */
            getCompanies() {
                if (this.companies && Object.values(this.companies).length) return new Promise(resolve => resolve(this.companies))
                return this.$store.dispatch('companies/getCompanies');
            },
        }
    }
</script>
<style lang="sass">
    .customer__finance

        .customer__finance__footer
            display: table-row
            font-size: 12px
            line-height: 14px
        .customer__finance__footer-item
            display: table-cell
            padding: 2px 5px 2px 5px

        // Таблиица
        .cell-field-sum .md-table-cell-container,
        .cell-field-balance_coming .md-table-cell-container,
        .cell-field-balance_consumption .md-table-cell-container,
        .cell-field-balance_sum .md-table-cell-container,
        .cell-field-balance_sum_before .md-table-cell-container,
        .cell-field-balance_sum_after .md-table-cell-container,

        // Заголовки таблицы
        .sort-table .component-sort-table__sum,
        .sort-table .component-sort-table__balance_coming,
        .sort-table .component-sort-table__balance_consumption,
        .sort-table .component-sort-table__balance_sum,
        .sort-table .component-sort-table__balance_sum_before,
        .sort-table .component-sort-table__balance_sum_after,

        // Сальдо
        .customer__finance__footer .footer-item__sum,
        .customer__finance__footer .footer-item__balance_coming,
        .customer__finance__footer .footer-item__balance_consumption,
        .customer__finance__footer .footer-item__balance_sum,
        .customer__finance__footer .footer-item__balance_sum_before,
        .customer__finance__footer .footer-item__balance_sum_after
            text-align: right

        .customer__finance-table-value-item
            &.finance
            &.deal
                color: #2196f3
            &.coming
                color: green
            &.consumption
                color: red
            &.minus
                color: red
            &.plus
                color: green
</style>


// WEBPACK FOOTER //
// CustomerFinance.vue?7a4b9524